<template>
  <ul class="navigation-bar">
    <!-- scan -->
    <li v-if="showScanIcon()" class="navigation-bar__link">
      <button aria-label="Scan Barcode" class="navigation-bar__barcode m-l-10" tabindex="0" @click="openScanModal">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
          data-prefix="fas"
          data-icon="barcode"
          class="navigation-bar__image navigation-bar__image--barcode svg-inline--fa"
          role="img"
          viewBox="0 0 512 512"
        >
          <path
            fill="currentColor"
            d="M0 448V64h18v384H0zm26.857-.273V64H36v383.727h-9.143zm27.143 0V64h8.857v383.727H54zm44.857 0V64h8.857v383.727h-8.857zm36 0V64h17.714v383.727h-17.714zm44.857 0V64h8.857v383.727h-8.857zm18 0V64h8.857v383.727h-8.857zm18 0V64h8.857v383.727h-8.857zm35.715 0V64h18v383.727h-18zm44.857 0V64h18v383.727h-18zm35.999 0V64h18.001v383.727h-18.001zm36.001 0V64h18.001v383.727h-18.001zm26.857 0V64h18v383.727h-18zm45.143 0V64h26.857v383.727h-26.857zm35.714 0V64h9.143v383.727H476zm18 .273V64h18v384h-18z"
          />
        </svg>
      </button>
    </li>

    <!-- favorites -->
    <li v-if="getUserData" class="navigation-bar__link navigation-bar__link--favorites">
      <app-link
        :route-to="{
          name: ROUTE_NAMES.FAVORITES,
          params: { vendor: getActiveVendor ? getActiveVendor.id : null }
        }"
        class="navigation-bar__favorites-link"
        :use-accent-color="false"
        :disabled="!getActiveVendor || enableFavOrdersLinks"
      >
        <svg
          class="navigation-bar__image svg-inline--fa"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <path
            fill="currentColor"
            d="M20.571 8.18c0-3.11-2.12-3.763-3.906-3.763-1.663 0-3.538 1.782-4.118 2.468-.268.32-.826.32-1.094 0-.58-.686-2.455-2.468-4.118-2.468-1.786 0-3.906.653-3.906 3.763 0 2.025 2.064 3.907 2.087 3.929L12 18.307l6.473-6.187c.034-.033 2.098-1.915 2.098-3.94zm1.429 0c0 2.656-2.455 4.88-2.556 4.98l-6.953 6.64c-.134.134-.312.2-.491.2s-.357-.066-.491-.2l-6.964-6.662C4.455 13.061 2 10.836 2 8.18 2 4.937 3.998 3 7.335 3 9.288 3 11.118 4.527 12 5.39 12.882 4.528 14.712 3 16.665 3 20.002 3 22 4.937 22 8.18z"
          />
        </svg>
        <span class="navigation-bar__link-text"> Favorites </span>
      </app-link>
    </li>

    <!-- order again -->
    <li v-if="getUserData" class="navigation-bar__link navigation-bar__link--order-again">
      <app-link
        :route-to="{
          name: ROUTE_NAMES.ORDER_AGAIN,
          params: { vendor: getActiveVendor ? getActiveVendor.id : null }
        }"
        class="navigation-bar__order-again-link"
        :use-accent-color="false"
        :disabled="enableFavOrdersLinks"
      >
        <svg
          class="navigation-bar__image svg-inline--fa"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <g fill="currentcolor">
            <path
              d="M11.999 6.02l-.003 5.246c0 .2.08.39.22.53l3.754 3.754 1.06-1.06-3.534-3.534.002-4.937h-1.5z"
              transform="translate(0 2)"
            />
            <path
              d="M13.5.02c-5.28 0-9.648 3.92-10.38 9H0l3.75 3.75L7.5 9.02H4.635c.718-4.25 4.414-7.5 8.865-7.5 4.963 0 9 4.036 9 9 0 4.962-4.037 9-9 9-2.79 0-5.377-1.263-7.097-3.465l-1.182.923c2.007 2.568 5.024 4.041 8.279 4.041 5.79 0 10.5-4.71 10.5-10.5C24 4.73 19.29.02 13.5.02z"
              transform="translate(0 2)"
            />
          </g>
        </svg>
        <span class="navigation-bar__link-text"> Order Again </span>
      </app-link>
    </li>

    <!-- dropdown -->
    <li v-if="isLoginAllowed" class="navigation-bar__link">
      <header-dropdown>
        <div class="navigation-bar__dropdown-button">
          <svg
            class="navigation-bar__image svg-inline--fa fa-user-circle fa-w-16"
            viewBox="0 0 28 28"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            height="28px"
            width="28px"
          >
            <defs>
              <path
                id="a"
                d="M13.418 0c7.409 0 13.415 6.007 13.415 13.418 0 7.409-6.006 13.415-13.415 13.415C6.007 26.833 0 20.827 0 13.418 0 6.007 6.007 0 13.418 0zM4.685 4.685c-4.823 4.823-4.823 12.64 0 17.467 4.823 4.822 12.64 4.822 17.467 0 4.822-4.826 4.822-12.644 0-17.467-4.826-4.823-12.644-4.823-17.467 0zm13.848 5.73c0 1.64-.857 3.106-2.19 3.921C19.097 15.324 21 17.966 21 21h-1.056c0-3.318-2.66-6.005-5.944-6.005-3.286 0-5.947 2.687-5.947 6.005H7c0-3.033 1.904-5.676 4.653-6.664-2.512-1.537-2.945-5.056-.86-7.162 2.818-2.848 7.74-.873 7.74 3.24zm-6.994-2.487c-1.36 1.371-1.36 3.599 0 4.97 1.35 1.365 3.571 1.365 4.922 0 1.357-1.371 1.357-3.599 0-4.97-1.36-1.374-3.565-1.374-4.922 0z"
              />
            </defs>
            <g fill="none" fill-rule="evenodd">
              <use fill="currentColor" fill-rule="nonzero" xlink:href="#a" />
            </g>
          </svg>
          <span v-if="!getUserData" class="navigation-bar__link-text navigation-bar__link-text--ml-large"> Sign-In </span>
          <span v-if="getUserData && getUserData.profile" class="navigation-bar__link-text navigation-bar-salute">
            Hello, {{ getUserData.profile.firstName }}!
          </span>
        </div>
      </header-dropdown>
    </li>

    <!-- shopping cart -->
    <li v-if="hideShoppingCartIcon" class="navigation-bar__link">
      <app-link :route-to="{ name: ROUTE_NAMES.SHOPPING_CART }" aria-label="My cart" class="navigation-bar__cart-link">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          width="26"
          height="26"
          viewBox="0 0 26 26"
        >
          <defs>
            <path
              id="s0u04eknga"
              d="M9.353 17.051c1.228 0 2.227 1.007 2.227 2.244 0 1.237-.999 2.243-2.227 2.243-1.228 0-2.227-1.006-2.227-2.243 0-1.237 1-2.244 2.227-2.244zm9.8 0c1.227 0 2.226 1.007 2.226 2.244 0 1.237-.999 2.243-2.227 2.243-1.228 0-2.227-1.006-2.227-2.243 0-1.237 1-2.244 2.227-2.244zm-9.8 1.496c-.409 0-.742.336-.742.748s.333.748.742.748c.41 0 .743-.336.743-.748s-.333-.748-.743-.748zm9.8 0c-.41 0-.743.336-.743.748s.333.748.742.748c.41 0 .743-.336.743-.748s-.333-.748-.743-.748zM5.114 0c.343 0 .64.231.714.556l.522 2.286h17.86c.23 0 .446.105.584.283.138.178.182.408.12.623l-2.924 9.946c-.09.305-.376.515-.702.515H8.036c-.402.002-.729.32-.729.71 0 .393.328.711.731.711h13.25c.404 0 .732.318.732.71 0 .393-.328.711-.731.711H8.039c-1.21 0-2.193-.956-2.193-2.131 0-.875.545-1.628 1.321-1.956l-1.15-5.037-.149-.647-1.339-5.86H.731C.327 1.42 0 1.104 0 .71 0 .318.327 0 .73 0zm18.128 4.263H6.676l1.948 8.525h12.114l2.505-8.525z"
            />
          </defs>
          <g fill="currentColor" fill-rule="evenodd">
            <g transform="translate(-330 -38) translate(0 24) translate(330 12) translate(0 2.154) translate(0 2.154)">
              <mask id="202c5ktbrb" fill="currentColor">
                <use xlink:href="#s0u04eknga" />
              </mask>
              <use fill="currentColor" fill-rule="nonzero" xlink:href="#s0u04eknga" />
            </g>
          </g>
        </svg>
        <app-indicator></app-indicator>
      </app-link>
    </li>
  </ul>
</template>

<script>
import { mapGetters } from "vuex";
import AppLink from "@/components/base/app-link/AppLink";
import AppIndicator from "../indicator/AppIndicator";
import HeaderDropdown from "@/components/header/header-dropdown/HeaderDropdown";
import ScanAndGoMixin from "@/mixins/scan-and-go.mixin";
import { ROUTE_NAMES } from "@/../app-constants";

export default {
  name: "NavigationBar",
  components: { AppIndicator, HeaderDropdown, AppLink },
  mixins: [ScanAndGoMixin],
  data: function () {
    return {
      ROUTE_NAMES
    };
  },
  computed: {
    ...mapGetters("user", ["getUserData"]),
    ...mapGetters("vendor", ["getActiveVendor"]),
    ...mapGetters("venueSettings", ["isLoginAllowed"]),
    ...mapGetters("cart", ["getCartSize"]),
    enableFavOrdersLinks() {
      return this.$route.name === ROUTE_NAMES.VENDOR_PICKER || this.$route.name === ROUTE_NAMES.VENUE_CONTAINER;
    },
    hideShoppingCartIcon() {
      if (
        [
          ROUTE_NAMES.LOGIN,
          ROUTE_NAMES.SHOPPING_CART,
          ROUTE_NAMES.ORDER_CONFIRMATION,
          ROUTE_NAMES.CHECKOUT,
          ROUTE_NAMES.CONTINUE_AS_GUEST,
          ROUTE_NAMES.VENUE_CONTAINER
        ].includes(this.$route.name)
      ) {
        return false;
      }
      return !(this.getCartSize === 0 && this.$route.name === ROUTE_NAMES.VENDOR_PICKER);
    }
  }
};
</script>

<style scoped lang="scss">
.navigation-bar {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  &__image {
    color: $group-1-color-2;

    &--barcode {
      width: 22px;
    }
  }

  &__link {
    display: block;
    position: relative;
    margin-left: ($spacer * 2);
  }

  &__link-text {
    margin-left: ($spacer * 0.5);

    &--ml-large {
      margin-left: ($spacer * 0.75);
    }
  }

  &-salute {
    height: max-content;
  }

  &__favorites {
    height: max-content;
    display: flex;
  }

  &__favorites-link {
    color: $group-1-color-2;
    display: flex;
    align-items: center;
  }

  &__order-again-link {
    color: $group-1-color-2;
    display: flex;
    align-items: center;
  }

  &__cart-link {
    color: $group-1-color-2;
    display: flex;
    align-items: center;
  }

  &__barcode {
    cursor: pointer;
    background: none;
    border: none;
    padding: 0;
  }

  &__dropdown-button {
    display: flex;
    align-items: center;
    &:hover {
      text-decoration: underline;
    }
  }

  &__dropdown {
    position: relative;
    display: inline-block;
    float: right;

    & > span {
      cursor: pointer;
    }

    & > .dropdown-content {
      display: none;
      position: absolute;
      background-color: #fff;
      min-width: 160px;
      box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
      z-index: 1;
      right: 0;

      &.show {
        display: block;
      }

      & > a {
        padding: ($spacer * 0.75) $spacer;
        text-decoration: none;
        display: block;
      }
    }
  }
  @include respond-to-mobile {
    .navigation-bar {
      padding: 0;

      &__link-text,
      &__link--favorites,
      &__link--order-again {
        display: none;
      }

      &__link {
        margin-left: ($spacer * 1.5);
      }
    }
  }
}
</style>
